import React, { useMemo } from 'react';
import { PromoCodeReportInterface } from 'types';
import LinesIcon from 'assets/icons/lines.svg?react';
import { MonthYear } from 'utils/monthYear';
import AGSimpleSelect, { SelectOption } from 'components/AGSelect/AGSimpleSelect/AGSimpleSelect';
import PieGraph from 'components/Dashboard/SpotGraphs/PieGraph';
import styles from './DiscountCodeReport.module.css';

type DiscountCodeReportProps = {
    discountCodeReport: PromoCodeReportInterface;
    monthYear: MonthYear['value'];
    monthYearOptions: SelectOption[];
    onMonthYearSelect: (option: string) => void;
};

function DiscountCodeReport({
    discountCodeReport,
    monthYear,
    monthYearOptions,
    onMonthYearSelect,
}: DiscountCodeReportProps) {
    const emptyReport = useMemo(() => {
        for (const key in discountCodeReport.promo_uses) {
            if (discountCodeReport.promo_uses[key] > 0) return false;
        }
        return true;
    }, [discountCodeReport]);

    return (
        <div className={styles.container}>
            <div className={styles.filters}>
                <h3 className={styles.title}>Discount Code Utilization</h3>

                <AGSimpleSelect
                    placeholder="Select a month"
                    selected={monthYear}
                    onSelect={onMonthYearSelect}
                    options={monthYearOptions}
                    icon={<LinesIcon />}
                    maxHeight="420px"
                />
            </div>
            {emptyReport ? (
                <p>No discount codes were used during this time period</p>
            ) : (
                <PieGraph
                    title="Usage by discount code"
                    dataLabel="Count of rentals"
                    description={'This is the count of rentals made using this discount code.'}
                    xData={Object.keys(discountCodeReport.promo_uses)}
                    yData={Object.values(discountCodeReport.promo_uses)}
                    style={{ maxHeight: 400 }}
                />
            )}
        </div>
    );
}

export default DiscountCodeReport;
